var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sliding-tabs',{staticClass:"JOB-TABS",attrs:{"activeTab":_vm.jobsStatusAlias,"disabled":_vm.disabled},on:{"change":_vm.handleClick}},_vm._l((_vm.tabs),function(tab,index){return _c('sliding-tabs-content',{key:tab.key,attrs:{"name":tab.key,"titleProps":{
        title: tab.label,
        titleClass: index ? 'text-capitalize' : 'FIRST-TAB-TITLE',
        suffix: _vm.getSuffix(tab.key),
        suffixClass: index ? undefined : 'BUBBLE',
        to: {
          name: 'dashboard::pro::jobs',
          params: { jobsStatusAlias: tab.key },
          query: _vm.$route.query,
        },
      }}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }